<script lang="ts">
  // OppHand — cartas do oponente (todas back-cover). Mostra so as
  // nao-jogadas, igual minha mao (regra Leonardo: jogou na mesa some).
  import type { Card as CardType } from '../../stores/match';
  import Card from './Card.svelte';

  // roundNumber e usado pra forcar re-mount via {#key} quando nova mao
  // deala — as cartas entram com anim de distribuicao.
  // revealCards (default false): se true E a carta tem value, renderiza
  // FACE-UP — usado durante mao de 11 em 2v2 pra parceiro ver mao um do
  // outro. Backend ja libera canSeeHand entao c.value/c.suit chegam
  // preenchidos no snap.
  type Props = {
    cards?: CardType[];
    roundNumber?: number;
    revealCards?: boolean;
  };
  let { cards = [], roundNumber = 0, revealCards = false }: Props = $props();

  let unplayed = $derived(cards.filter((c) => !c.played));
</script>

<div class="opp-hand">
  {#key roundNumber}
    {#each unplayed as card, i (i)}
      <div
        class="slot card-deal"
        style="animation-delay: {i * 110}ms"
      >
        {#if revealCards && card?.value && card?.suit}
          <Card {card} size="md" />
        {:else}
          <Card size="md" />
        {/if}
      </div>
    {/each}
  {/key}
  {#if unplayed.length === 0}
    <div class="empty">—</div>
  {/if}
</div>

<style>
  .opp-hand {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: clamp(4px, 1vw, 6px);
    padding: clamp(2px, 0.8vh, 8px);
    /* Reserva espaco pra 3 cartas mesmo quando hand fica vazia (cartas
     * jogadas viajam pra mesa). Sem isso, o seat encolhe e o avatar
     * desliza — Felipe 2026-05-20. Default = horizontal (partner top).
     * Override no side-seat coluna (.left/.right) abaixo do GameView2v2. */
    min-width: calc(var(--card-w-md) * 3 + 18px);
    min-height: calc(var(--card-w-md) * 1.5 + 12px);
  }
  .empty {
    color: var(--text-dim);
    font-size: 11px;
    align-self: center;
  }
</style>
